import { render, staticRenderFns } from "./PaymentGeneralKasbonView.vue?vue&type=template&id=27ca42fd"
import script from "./PaymentGeneralKasbonView.vue?vue&type=script&lang=js"
export * from "./PaymentGeneralKasbonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports